export function scrollAnchors() {
  $('a[data-link]').click(function(e){
    e.preventDefault();
    const anchor = $(this).attr('data-link')
    const header = $('.header').outerHeight()
    const target = $('[data-anchor="'+anchor+'"]')
    if(target){
      const offset = target && target.hasClass('section-container') ? 33 : header;
      $([document.documentElement, document.body]).animate({
        scrollTop: target.offset().top - offset,
      }, 500)
    }  
  })
}